import {makeStyles, Theme, createStyles} from "@material-ui/core/styles";
import {Box, InputBase, IconButton} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      justifyContent: "space-between",
      width: "380px",
      backgroundColor: theme.palette.input.light,
      border: `1px solid ${theme.palette.primary.light}`,
      borderRadius: "16px",
    },

    inputBase: {
      flexGrow: 1,
      paddingLeft: "20px",
    },
  })
);

type SearchFormProps = {
  setSearchWord: (inputWord: string) => void;
  searchDispatcher: (page?: number, inputWord?: string) => void;
  page?: number;
  searchWord?: string;
};

const SearchForm = ({setSearchWord, searchDispatcher, page, searchWord}: SearchFormProps) => {
  const classes = useStyles();

  const searchHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputWord = (event.target as HTMLInputElement).value.trim();
    setSearchWord(inputWord);
    searchDispatcher(page, inputWord);
    sessionStorage.setItem("projectSearchWord", inputWord);
  };

  return (
    <Box>
      <form
        className={classes.root}
        autoComplete="off"
        onSubmit={(event: React.FormEvent<HTMLFormElement>) => event.preventDefault()}
      >
        <InputBase
          className={classes.inputBase}
          placeholder="Search"
          inputProps={{"aria-label": "search factory"}}
          onChange={searchHandler}
          defaultValue={searchWord}
        />
        <IconButton aria-label="search">
          <SearchIcon />
        </IconButton>
      </form>
    </Box>
  );
};

export default SearchForm;
